import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
import { Dialog, DialogContent, DialogTitle, Grid } from '@mui/material';

import FormActionButtons from 'components/ui/form/FormActionButtons';
import FormTextField from 'components/ui/form/FormTextField';
import useFormSubmit from 'hooks/useFormSubmit';
import { memo } from 'react';

import useSearch from 'hooks/useSearch';
import FormSelectField from 'components/ui/form/FormSelectField';

const validationSchema = yup.object({
  name: yup.string().required('crm.block.addModal.validation.name'),
});

const WidgetAddModal = ({ open, setOpen, refetchFn }) => {
  const query = useSearch();
  const { t } = useTranslation();

  const { submit, isSubmitting } = useFormSubmit();

  const formik = useFormik({
    initialValues: {
      name: '',
      dashboard_id: query.get('dashboard'),
      type: '',
      event: '',
      ObjectId: '',
      FilterBy: '',
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      submit(
        { type: 'post', contentType: 'simple' },
        values,
        '/admin/widgets/widgetstore',
        {
          title: t('dashboard.addedWidget'),
        },
        null,
        true,
        handleFinish
      );
    },
  });

  const handleFinish = () => {
    refetchFn();
    handleClose();
  };

  const handleClose = () => {
    setOpen(false);
    formik.resetForm();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      maxWidth='lg'
      PaperProps={{
        className: '!shadow-none !base-border',
      }}
      disableEscapeKeyDown={true}
    >
      <DialogTitle
        id='alert-dialog-title'
        className='text-center bg-gray-100 !`mb-2'
      >
        <span className='pr-5'>{t('common.button.addNew')}</span>
      </DialogTitle>

      <DialogContent>
        <form onSubmit={formik.handleSubmit} className='pt-2'>
          <Grid
            container
            spacing={{ xs: 2, sm: 2, md: 2 }}
            rowSpacing={1}
            columns={{ xs: 12, sm: 12, md: 12 }}
          >
            <Grid item={true} md={6} sm={12} xs={12}>
              <FormTextField
                delay={0.1}
                label={t('common.fields.simpleName')}
                fieldName='name'
                formik={formik}
              />
            </Grid>
            <Grid item={true} md={6} sm={12} xs={12}>
              <FormSelectField
                delay={0.3}
                label={t('common.fields.type')}
                fieldName='type'
                formik={formik}
                path={'/admin/widgets/types'}
                optionValueName='type'
              />
            </Grid>
            {formik?.values?.type === 'COMETOOFFICE' ? (
              <Grid item={true} md={6} sm={12} xs={12}>
                <FormSelectField
                  delay={0.3}
                  label={t('common.filter.object_type')}
                  fieldName='ObjectId'
                  formik={formik}
                  path={'/crm/crm-settings/fields'}
                  // optionValueName='type'
                />
              </Grid>
            ) : null}

            <Grid item={true} sm={12} xs={12}>
              <FormActionButtons
                delay={0.3}
                isSubmitting={isSubmitting}
                formType='dialog'
                setOpen={setOpen}
                reset={formik.resetForm}
              />
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default memo(WidgetAddModal);
